import React, { forwardRef } from 'react';
import Link, { LinkProps } from 'next/link';
import { useRouter } from 'next/router';
import { analyzeUrl } from '../../utils/cjsutils';

interface Props
  extends LinkProps,
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  //^ fixes conflict between <a>'s href and <Link>'s
  className?: string;
}

const AppSafeLink = forwardRef<HTMLAnchorElement, Props>(
  ({ href, children, ...rest }, ref) => {
    if (!href) href = '/';
    const router = useRouter();
    const hasAppParam =
      router.asPath.includes('?app') || router.asPath.includes('&app');

    const { isInternal } = analyzeUrl(href);

    const preparedHref = href
      .toString()
      .replace(/^https?:\/\/(www\.)?mprnews\.org/, '');

    return (
      <Link
        ref={ref}
        href={`${preparedHref}${hasAppParam && isInternal ? '?app' : ''}`}
        {...rest}
      >
        {children}
      </Link>
    );
  }
);

AppSafeLink.displayName = 'AppSafeLink';

export default AppSafeLink;
